<template>
    <div class="main-container">
        <header-gift-cert @closeDialog="closeDialog" />
        <main-gift-cert />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderGiftCert from './HeaderGiftCert.vue';
import MainGiftCert from './MainGiftCert.vue';

const dialogRef = getDialogRef(ModalNames.GIFTCERT);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-container {
    @apply sm:max-w-lg sm:w-full w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto sm:p-9 p-6 gap-9 flex flex-col;
}
</style>
